import MuiSelectCommunity from './MuiSelectCommunity';

export default MuiSelectCommunity;
